// Auto-generated by scripts/generate-registry.mjs from packages/modules/rattan_pillow_table_lamp/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const rattan_pillow_table_lamp: ModuleSchema = {
  "id": "rattan_pillow_table_lamp",
  "uniqueId": "B3D_S8K8T",
  "createdAt": "2026-10-23T09:53:41.236Z",
  "updatedAt": "2026-10-23T11:29:09.704Z",
  "label": "Rattan Pillow Lamp",
  "description": "Four original woven rattan pillow-form tiers stacked on a stable table-lamp base.",
  "category": "lamps",
  "tags": [
    "rattan-pillow-table-lamp"
  ],
  "sliders": [
    {
      "key": "tierSpacing",
      "label": "Tier Spacing",
      "min": 37.5,
      "max": 50,
      "default": 37.8,
      "step": 0.1,
      "unit": "mm",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseDiameter",
      "label": "Base Diameter",
      "min": 90,
      "max": 180,
      "default": 110,
      "step": 1,
      "unit": "mm",
      "enabled": false,
      "visible": false
    },
    {
      "key": "baseHeight",
      "label": "Base Height",
      "min": 20,
      "max": 60,
      "default": 39.4,
      "step": 0.1,
      "unit": "mm",
      "enabled": false,
      "visible": false
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "tier_1",
      "label": "Original Core - Tier 1",
      "default": "#D97706",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "tier_2",
      "label": "Original Core - Tier 2",
      "default": "#D97706",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "tier_3",
      "label": "Original Core - Tier 3",
      "default": "#D97706",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "tier_4",
      "label": "Original Core - Tier 4",
      "default": "#D97706",
      "targetGroupIds": [
        3
      ]
    },
    {
      "key": "base_and_support",
      "label": "Base and Center Support",
      "default": "#334155",
      "targetGroupIds": [
        4
      ]
    }
  ],
  "objects": [
    {
      "id": "rattan_shade",
      "label": "Four Original Rattan Tiers",
      "name": "Four Original Rattan Tiers",
      "color": "#D97706",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "tier_1",
          "label": "Original Core - Tier 1",
          "name": "Original Core - Tier 1",
          "groupId": 0,
          "colorKey": "tier_1",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        },
        {
          "id": "tier_2",
          "label": "Original Core - Tier 2",
          "name": "Original Core - Tier 2",
          "groupId": 1,
          "colorKey": "tier_2",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        },
        {
          "id": "tier_3",
          "label": "Original Core - Tier 3",
          "name": "Original Core - Tier 3",
          "groupId": 2,
          "colorKey": "tier_3",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        },
        {
          "id": "tier_4",
          "label": "Original Core - Tier 4",
          "name": "Original Core - Tier 4",
          "groupId": 3,
          "colorKey": "tier_4",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    },
    {
      "id": "lamp_base",
      "label": "Lamp Base",
      "name": "Lamp Base",
      "color": "#334155",
      "assembled_z_offset": 0,
      "exploded_z_offset": 50,
      "parts": [
        {
          "id": "base_and_support",
          "label": "Base and Center Support",
          "name": "Base and Center Support",
          "groupId": 4,
          "colorKey": "base_and_support",
          "defaultColor": "#334155",
          "assembled_z_offset": 0,
          "exploded_z_offset": 50,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Lamp"
    },
    {
      "id": "shade",
      "label": "Download STL - Four-Tier Shade"
    },
    {
      "id": "base",
      "label": "Download STL - Base"
    }
  ]
};
